import { useQuery } from '@tanstack/react-query';

import { type EmojiWasm, type WasmType } from '@app/store/types/emoji';

import { importEmojiWasm } from './request';

export type EmojiWasmReturn = ReturnType<typeof useEmojiWasm>;

export function useEmojiWasm<T = EmojiWasm>(wasmType?: WasmType) {
    const cache = ['wasm', `emoji-wasm-${wasmType ?? 'default'}`];
    const { data, error, status, isFetched, isFetching } = useQuery(cache, () => importEmojiWasm<T>(wasmType), {
        retry: false,
        enabled: true,
        staleTime: Infinity,
    });

    return {
        emojiWasm: data,
        error,
        status,
        fetched: isFetched,
        fetching: isFetching,
    };
}
